import { GenderComposition } from "@/openapi/generated";
import { formatDecimal, parseDecimal } from "@/lib/utils/format-decimal";

function toAgeNumber(value: unknown): number | null {
  return parseDecimal(value);
}

export function formatAgeNumber(value: unknown): string | null {
  const age = toAgeNumber(value);
  return age == null ? null : formatDecimal(age);
}

/** Compact admin label, e.g. "4.5 – 6.5 years". */
export function formatClassAgeRangeCompact(
  minAge: unknown,
  maxAge: unknown,
): string | null {
  const min = formatAgeNumber(minAge);
  const max = formatAgeNumber(maxAge);

  if (min != null && max != null) {
    return min === max ? `${min} years` : `${min} – ${max} years`;
  }
  if (min != null) return `${min}+ years`;
  if (max != null) return `Up to ${max} years`;
  return null;
}

/** Public-facing age range for class detail pages. */
export function formatClassAgeRange(minAge: unknown, maxAge: unknown): string | null {
  const min = formatAgeNumber(minAge);
  const max = formatAgeNumber(maxAge);

  if (min != null && max != null) {
    return min === max ? `Age ${min}` : `Ages ${min}–${max}`;
  }
  if (min != null) return `Ages ${min}+`;
  if (max != null) return `Up to age ${max}`;
  return null;
}

/** Public-facing gender composition label. */
export function formatClassGenderComposition(
  gender: GenderComposition | null | undefined,
): string | null {
  if (!gender) return null;

  switch (gender) {
    case GenderComposition.Male:
      return "Boys only";
    case GenderComposition.Female:
      return "Girls only";
    case GenderComposition.Coeducation:
      return "Co-ed";
    default:
      return String(gender);
  }
}
